import React, { forwardRef, ComponentPropsWithoutRef, ReactElement } from "react";
import { StoryCard } from "@govlaunch/story";

interface IStoryCardWithPlaceholderProps extends ComponentPropsWithoutRef<typeof StoryCard> {
  translationLinkWrap?: (slug: string) => ReactElement | null;
}

const StoryCardWithPlaceholder = forwardRef<any, IStoryCardWithPlaceholderProps>(
  ({ story, translationLinkWrap, ...props }, ref) => {
    return (
      <StoryCard
        story={story}
        placeholderImageSrc="/static/story/story-card-placeholder.png"
        ref={ref}
        translationLinkWrap={translationLinkWrap}
        {...props}
      />
    );
  },
);

StoryCardWithPlaceholder.displayName = "StoryCardWithPlaceholder";

export default StoryCardWithPlaceholder;
